import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionTanks } from '../../../actions/tanks_actions.jsx';
import * as styles from "../tanks.module.scss";
import AreaView from '../area/area_view.jsx';
import { withTranslation, Trans } from 'react-i18next';
import { NavLink } from 'react-router-dom';

const Columns = [
    {
        header: "Tanks.tankName",
        name: "tankName"
    },
    {
        header: "Tanks.volume",
        name: "volume"
    }
];

class TanksList extends React.Component {
    constructor(props) {
        super(props);
        this.getData = this.getData.bind(this);
        this.addTank = this.addTank.bind(this);
        this.addArea = this.addArea.bind(this);
        this.selectTank = this.selectTank.bind(this);
        //this.editTank = this.editTank.bind(this);
    }
    
    componentDidMount() {
        this.getData();
    }
    
    getData() {
        this.props.getAreas();
    }

    addArea() {
        this.props.history.push('/tanks/addArea');
    }

    addTank(areaId) {
        this.props.history.push('/tanks/' + areaId + "/addTank/");
    }

    selectTank(tank) {
        this.props.history.push('/tanks/tankdetails/' + tank.tankId);
    }

    //editTank(tank) {
    //    this.props.history.push('/tanks/editTank/' + tank.tankId);
    //}

    render() {
        return (
            <div>
                <div className={styles.tanks_page_header}>
                    <div className={styles.right_buttons_container}>
                        <button className={styles.add_item_button} onClick={this.addArea}></button>
                    </div>
                </div>
               
                <div className={styles.tanks_page_body}>
                    {
                        this.props.areas.map((item, index) => {
                            return (<div key={index}>
                                <AreaView area={item} selectTankFunction={this.selectTank} addTankFunction={this.addTank}/>
                                </div>);
                        })
                    }
                </div>
            </div>
        );
    }
}

//<Table settings={{
//    columns: Columns,
//    items: this.props.tanks,
//    itemsFilter: this.props.filter,
//    isEditable: true,
//    getItemsFunction: this.getData,
//    addItemFunction: this.addTank,
//    editItemFunction: this.editTank
//}} />

function mapStateToProps(state) {
    return {
        areas: state.tanks.areas,
        filter: state.tanks.filter,
        loading: state.tanks.loading,
        errors: state.tanks.errors,
        forceReload: state.tanks.forceReload
    };
}

export default connect(
        mapStateToProps,
        dispatch => bindActionCreators(actionTanks, dispatch)
)(withTranslation('translations')(TanksList));